import { signIn, SignInInput, signUp, SignUpInput, signOut, fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from "aws-amplify/utils";
import { deleteCookie, setCookie } from '.';

async function setCookies() {
  fetchAuthSession()
    .then(({ tokens: session }) => {
      const isAuthenticated = !!session;
      localStorage.setItem('authenticated', isAuthenticated.toString());

      if (isAuthenticated) {
        const userId = session.idToken?.payload?.sub || session.accessToken?.payload?.sub;

        if (userId) {
          localStorage.setItem('p_tguid', userId);
          localStorage.setItem('p_tguid_updated_at', Date.now().toString());
          setCookie('idToken', `${session.idToken}`, 0.5)
          setCookie('accessToken', `${session.accessToken}`, 0.5)
          deleteCookie('docu.idToken')
        }
      }
    })
    .catch(() => {
      localStorage.setItem('authenticated', 'false');
      deleteCookie('idToken')
      deleteCookie('accessToken')
      deleteCookie('docu.idToken')
    })
    .finally(() => {
      deleteCookie('docu.idToken')
    });
}


function listenToAutoSignInEvent() {
  Hub.listen('auth', ({ payload }) => {
    const { event } = payload;
    // TODO autosignin is not supported in aws amplify v6, not sure if just sign in does the same job
    if (event === 'signedIn') {
      console.log('Hub signedIn')
      setCookies()

    } else if (event === 'signedOut') {
      console.log('Hub signedOut')
      localStorage.setItem('authenticated', `false`)
      deleteCookie('idToken')
      deleteCookie('accessToken')
      deleteCookie('docu.idToken')
    }
  })
}


export const services = {
  // async validateCustomSignUp(input: SignUpInput) {
  //   // Below is a sample validation code that uses a non-existent custom "acknowledgement" control do demo amplify built-in custom validation 
  //   // if (!formData.acknowledgement) {
  //   //   return {
  //   //     acknowledgement: translate(strings.LOGIN_TERMS_CONDITION),
  //   //   }
  //   // }
  // },

  async handleSignUp(input: SignUpInput) {
    // custom username and email
    const { username, password, options } = input;
    const customUsername = username.toLowerCase();
    const customEmail = options?.userAttributes?.email?.toLowerCase();
    const signUpResult = await signUp({
      username: customUsername,
      password,
      options: {
        ...input.options,
        userAttributes: {
          ...input.options?.userAttributes,
          email: customEmail,
        },
        autoSignIn: {
          enabled: true,
        },
      },
    })

    // Make sure user attributes are set in localStorage.
    listenToAutoSignInEvent()

    return signUpResult
  },

  async handleSignIn(input: SignInInput) {
    console.log('handleSignIn')

    const { username, password } = input
    const user = await signIn({
      username,
      password
    })
    setCookies()

    return user
  },

  async handleSignOut() {
    console.log('handleSignOut')
    await signOut()
    deleteCookie('idToken')
    deleteCookie('accessToken')
    deleteCookie('docu.idToken')
  }
}